import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import FormField from '../../common/form-field';
import { FormComponent, FormComponentProps } from '../index';
import { useTranslation } from 'react-i18next';
import './label-total.css';
import { useFormContext } from 'react-hook-form';
import { parseError } from '../../../services/utils';

export default function LabelTotal(name: string, value: string): FormComponent {
  return ({ ...rest }) => (
    <LabelTotalComponent value={value} name={name} {...rest} />
  );
}

export function LabelTotalComponent({
  name,
  value,
  parentName,
}: FormComponentProps & {
  name: string;
  value: string;
}) {
  const { t } = useTranslation();
  const labelName = parentName ? `${parentName}.${name}` : name;

  const {
    formState: { errors },
  } = useFormContext();
  const error = parseError(name, errors);

  return (
    <FormField labelFor={labelName} label={''} error={error?.message}>
      <div className="label-total">
        <label className="description" style={{ width: '368px' }}>
          {t('total')}
        </label>
        <label>{value + ' ' + t('days')}</label>
      </div>
    </FormField>
  );
}
